export const TIMER_CONFIG = {
    DEFAULT_SECONDS: 30,
    MAX_MINUTES: 99,
    MAX_SECONDS: 59,
    TICK_INTERVAL: 1000,
};
